import styled from 'styled-components';
import { Image } from 'react-bootstrap';

const ICON_SIZE = '17px';

export const SearchIcon = styled(Image)`
  cursor: pointer;
  height: ${({ height }) => height || ICON_SIZE};
  width: ${({ width }) => width || ICON_SIZE};
`;
